import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Footer = () => {
    return (
        <Container>
            <Row className="justify-content-md-center p-5">
                <Col md="auto">
                    <div className="custom-text">Copyright © 2026 Shorts Creator. All rights reserved</div>
                </Col>
            </Row>
        </Container>
    );
};

export default Footer; 